import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "check-attempts-panel"
}
const _hoisted_2 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_3 = {
  class: "flex items-end gap-2",
  "data-testid": "filter-period"
}
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-red-600",
  "data-testid": "filter-range-error"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-red-600",
  "data-testid": "check-attempts-error"
}
const _hoisted_6 = {
  key: 2,
  class: "grid grid-cols-3 gap-3"
}
const _hoisted_7 = {
  class: "rounded-lg border border-gray-100 bg-gray-50 px-3 py-2",
  "data-testid": "check-attempts-kpi-total"
}
const _hoisted_8 = { class: "text-lg font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] uppercase tracking-wide text-gray-500" }, "Tentativas", -1)
const _hoisted_10 = {
  class: "rounded-lg border border-gray-100 bg-gray-50 px-3 py-2",
  "data-testid": "check-attempts-kpi-rejected"
}
const _hoisted_11 = { class: "text-lg font-bold text-red-600" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] uppercase tracking-wide text-gray-500" }, "Rejeitadas", -1)
const _hoisted_13 = {
  class: "rounded-lg border border-gray-100 bg-gray-50 px-3 py-2",
  "data-testid": "check-attempts-kpi-max-distance"
}
const _hoisted_14 = { class: "text-lg font-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] uppercase tracking-wide text-gray-500" }, "Maior distância rejeitada", -1)
const _hoisted_16 = {
  key: 4,
  class: "rounded-xl border border-dashed border-gray-200 bg-gray-50 p-4 text-sm text-gray-400",
  "data-testid": "check-attempts-map-empty"
}
const _hoisted_17 = { class: "flex gap-4 text-xs text-gray-600" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline-block h-2.5 w-2.5 rounded-full align-middle bg-blue-500" }),
  /*#__PURE__*/_createTextVNode(" raio atual da unidade")
], -1)
const _hoisted_19 = {
  key: 5,
  class: "rounded-lg border border-gray-100 p-4 text-sm text-gray-500",
  "data-testid": "check-attempts-empty"
}
const _hoisted_20 = {
  key: 6,
  class: "overflow-x-auto"
}
const _hoisted_21 = { class: "w-full text-sm" }
const _hoisted_22 = { class: "text-left text-[11px] uppercase tracking-wide text-gray-500" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Data/hora", -1)
const _hoisted_24 = {
  key: 0,
  class: "py-2 pr-3"
}
const _hoisted_25 = {
  key: 1,
  class: "py-2 pr-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Tipo", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Resultado", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Distância", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Raio", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Pino na hora", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "Coordenadas", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-3" }, "App", -1)
const _hoisted_33 = ["data-testid", "onClick"]
const _hoisted_34 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_35 = {
  key: 0,
  class: "py-2 pr-3"
}
const _hoisted_36 = {
  key: 1,
  class: "py-2 pr-3 whitespace-nowrap"
}
const _hoisted_37 = { class: "py-2 pr-3" }
const _hoisted_38 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_41 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_42 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_43 = { class: "py-2 pr-3 whitespace-nowrap" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 7,
  class: "flex justify-center"
}

import { computed, defineAsyncComponent, onMounted, ref, watch } from 'vue'
import { mdiAlertOutline } from '@mdi/js'
import { useToast } from 'vue-toastification'
import GoogleMaps from '@/components/GoogleMaps.vue'
import {
  CHECK_ATTEMPT_REASON_LABELS,
  CHECK_ATTEMPT_TYPE_LABELS
} from '@/Network/Types/Responses/CheckAttemptsResponses'
import {
  useCheckAttempts,
  isHealthUnitSource,
  MAX_RANGE_DAYS,
  type CheckAttemptsSource,
  type CheckAttemptsUiFilters
} from './useCheckAttempts'
import {
  ACCEPTED_COLOR,
  REJECTED_COLOR,
  formatCoords,
  formatDistance,
  mapsLink,
  reasonLabel
} from './checkAttemptsFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckAttemptsPanel',
  props: {
    source: {},
    compact: { type: Boolean, default: false },
    initialFilters: { default: undefined }
  },
  emits: ["update:filters"],
  setup(__props: any, { emit }) {

const props = __props;




const excelIcon = defineAsyncComponent(() => import('@/assets/icons/excel.vue'))
const toast = useToast()

const state = useCheckAttempts(props.source, props.initialFilters)
const isUnit = computed(() => isHealthUnitSource(props.source))
const rangeError = ref<string | null>(null)
const isExporting = ref(false)

const typeOptions = Object.entries(CHECK_ATTEMPT_TYPE_LABELS).map(([value, title]) => ({
  value,
  title
}))
const outcomeOptions = [
  { value: 'ACCEPTED', title: 'Aceita' },
  { value: 'REJECTED', title: 'Rejeitada' }
]
const reasonOptions = Object.entries(CHECK_ATTEMPT_REASON_LABELS).map(([value, title]) => ({
  value,
  title
}))

const isSdkReady = computed(
  () =>
    typeof window !== 'undefined' &&
    !!(window as unknown as { google?: { maps?: unknown } }).google?.maps
)
const mapCenter = computed(() => {
  const hu = state.healthUnit.value
  if (!isSdkReady.value || !hu || hu.latitude == null || hu.longitude == null) return null
  return { lat: hu.latitude, lng: hu.longitude }
})

function validateRange(): boolean {
  rangeError.value = null
  if (!isUnit.value) return true
  const { startDate, endDate } = state.filters.value
  const days = (Date.parse(endDate) - Date.parse(startDate)) / 86_400_000
  if (Number.isNaN(days) || days < 0) rangeError.value = 'Período inválido'
  else if (days > MAX_RANGE_DAYS) rangeError.value = `Período máximo de ${MAX_RANGE_DAYS} dias`
  return rangeError.value === null
}

async function load(): Promise<void> {
  if (!validateRange()) return
  await state.load()
  emit('update:filters', { ...state.filters.value })
}

async function apply(): Promise<void> {
  state.page.value = 1
  await load()
}

async function reset(): Promise<void> {
  state.resetFilters()
  await load()
}

async function exportXlsx(): Promise<void> {
  if (!validateRange()) return
  isExporting.value = true
  try {
    const link = await state.exportXlsx()
    link.click()
    link.remove()
    toast.success('Planilha exportada com sucesso')
  } catch (e) {
    toast.error(e instanceof Error ? e.message : 'Não foi possível exportar as tentativas de check')
  } finally {
    isExporting.value = false
  }
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function formatStation(s: { date: string; startHour: string; endHour: string }): string {
  const hh = (iso: string) =>
    new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  return `${new Date(s.date).toLocaleDateString('pt-BR')} ${hh(s.startHour)}–${hh(s.endHour)}`
}

watch(
  () => props.source,
  () => apply(),
  { deep: true }
)
onMounted(load)

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isUnit.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(state).filters.value.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).filters.value.startDate) = $event)),
                type: "date",
                label: "De",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                class: "w-44"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _unref(state).filters.value.endDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).filters.value.endDate) = $event)),
                type: "date",
                label: "Até",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                class: "w-44"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_v_autocomplete, {
              modelValue: _unref(state).filters.value.doctorId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).filters.value.doctorId) = $event)),
              items: _unref(state).doctors.value,
              "item-title": "name",
              "item-value": "id",
              label: "Médico",
              density: "compact",
              variant: "outlined",
              clearable: "",
              "hide-details": "",
              class: "min-w-[220px]",
              "data-testid": "filter-doctor"
            }, null, 8, ["modelValue", "items"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_v_select, {
        modelValue: _unref(state).filters.value.type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).filters.value.type) = $event)),
        items: _unref(typeOptions),
        label: "Tipo",
        density: "compact",
        variant: "outlined",
        clearable: "",
        "hide-details": "",
        class: "w-36",
        "data-testid": "filter-type"
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_v_select, {
        modelValue: _unref(state).filters.value.outcome,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).filters.value.outcome) = $event)),
        items: outcomeOptions,
        label: "Resultado",
        density: "compact",
        variant: "outlined",
        clearable: "",
        "hide-details": "",
        class: "w-40",
        "data-testid": "filter-outcome"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_select, {
        modelValue: _unref(state).filters.value.reason,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).filters.value.reason) = $event)),
        items: _unref(reasonOptions),
        label: "Motivo",
        density: "compact",
        variant: "outlined",
        clearable: "",
        "hide-details": "",
        class: "min-w-[200px]",
        "data-testid": "filter-reason"
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        loading: _unref(state).isLoading.value,
        "data-testid": "filter-apply",
        onClick: apply
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Aplicar ")
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_v_btn, {
        variant: "text",
        "data-testid": "filter-reset",
        onClick: reset
      }, {
        default: _withCtx(() => [
          _createTextVNode("Limpar")
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "primary",
        loading: isExporting.value,
        disabled: _unref(state).isLoading.value,
        "data-testid": "filter-export",
        onClick: exportXlsx
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(excelIcon), {
            width: "18",
            height: "18",
            color: "currentColor",
            class: "mr-2"
          }),
          _createTextVNode(" Exportar Excel ")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    (rangeError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(rangeError.value), 1))
      : _createCommentVNode("", true),
    (_unref(state).error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(state).error.value), 1))
      : _createCommentVNode("", true),
    (_unref(state).summary.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(state).summary.value.total), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(state).summary.value.rejected), 1),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(formatDistance)(_unref(state).summary.value.maxRejectedDistanceM)), 1),
            _hoisted_15
          ])
        ]))
      : _createCommentVNode("", true),
    (mapCenter.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass([_ctx.compact ? 'h-56' : 'h-80', "w-full overflow-hidden rounded-xl border border-gray-100"]),
          "data-testid": "check-attempts-map"
        }, [
          _createVNode(GoogleMaps, {
            latitude: mapCenter.value.lat,
            longitude: mapCenter.value.lng,
            radius: _unref(state).healthUnit.value?.reachRadiusM ?? undefined,
            draggable: false,
            "show-info": false,
            points: _unref(state).points.value,
            "selected-point-id": _unref(state).selectedId.value ?? undefined,
            onPointClick: _unref(state).select
          }, null, 8, ["latitude", "longitude", "radius", "points", "selected-point-id", "onPointClick"])
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, " Mapa indisponível (unidade sem coordenadas ou SDK não carregado). ")),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("span", null, [
        _createElementVNode("i", {
          class: "inline-block h-2.5 w-2.5 rounded-full align-middle",
          style: _normalizeStyle({ background: _unref(ACCEPTED_COLOR) })
        }, null, 4),
        _createTextVNode(" aceita")
      ]),
      _createElementVNode("span", null, [
        _createElementVNode("i", {
          class: "inline-block h-2.5 w-2.5 rounded-full align-middle",
          style: _normalizeStyle({ background: _unref(REJECTED_COLOR) })
        }, null, 4),
        _createTextVNode(" rejeitada")
      ]),
      _hoisted_18
    ]),
    (!_unref(state).isLoading.value && _unref(state).items.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Nenhuma tentativa registrada no período. Tentativas em que o app não conseguiu obter a localização (permissão negada ou GPS indisponível) ainda não são enviadas ao servidor. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_22, [
                _hoisted_23,
                (isUnit.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_24, "Médico"))
                  : _createCommentVNode("", true),
                (isUnit.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Plantão"))
                  : _createCommentVNode("", true),
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _hoisted_31,
                _hoisted_32
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: _normalizeClass(["cursor-pointer border-t border-gray-100 hover:bg-gray-50", { 'is-selected bg-primary/5': _unref(state).selectedId.value === item.id }]),
                  "data-testid": `check-attempts-row-${item.id}`,
                  onClick: ($event: any) => (_unref(state).select(item.id))
                }, [
                  _createElementVNode("td", _hoisted_34, _toDisplayString(formatDateTime(item.createdAt)), 1),
                  (isUnit.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(item.doctor?.name ?? '—'), 1))
                    : _createCommentVNode("", true),
                  (isUnit.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                        (item.station)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("#" + _toDisplayString(item.station.id) + " · " + _toDisplayString(formatStation(item.station)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("—")
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(CHECK_ATTEMPT_TYPE_LABELS)[item.type]), 1),
                  _createElementVNode("td", _hoisted_38, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-block max-w-[220px] truncate whitespace-nowrap align-middle rounded-full px-2 py-0.5 text-[11px] font-semibold", 
                  item.outcome === 'ACCEPTED'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                ]),
                      "data-testid": "check-attempts-result-pill",
                      title: item.message ?? ''
                    }, _toDisplayString(_unref(reasonLabel)(item)), 11, _hoisted_39)
                  ]),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(formatDistance)(item.distanceM)), 1),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(formatDistance)(item.reachRadiusM)), 1),
                  _createElementVNode("td", _hoisted_42, [
                    _createTextVNode(_toDisplayString(_unref(formatCoords)(item.unitLatitude, item.unitLongitude)) + " ", 1),
                    (item.unitPinDiffersFromCurrent)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          icon: _unref(mdiAlertOutline),
                          size: "16",
                          class: "text-amber-600",
                          title: "Pino da unidade era diferente do atual",
                          "data-testid": "pin-differs"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_43, [
                    (item.checkLatitude != null && item.checkLongitude != null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _unref(mapsLink)(item.checkLatitude, item.checkLongitude),
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "text-primary30 hover:underline",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                        }, _toDisplayString(_unref(formatCoords)(item.checkLatitude, item.checkLongitude)), 9, _hoisted_44))
                      : (_openBlock(), _createElementBlock("span", _hoisted_45, "—"))
                  ]),
                  _createElementVNode("td", {
                    class: "py-2 pr-3 max-w-[160px] truncate",
                    title: item.userAgent ?? ''
                  }, _toDisplayString(item.userAgent ?? '—'), 9, _hoisted_46)
                ], 10, _hoisted_33))
              }), 128))
            ])
          ])
        ])),
    (_unref(state).pageCount.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createVNode(_component_v_pagination, {
            modelValue: _unref(state).page.value,
            "onUpdate:modelValue": [
              _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).page.value) = $event)),
              load
            ],
            length: _unref(state).pageCount.value,
            "total-visible": 5,
            density: "comfortable"
          }, null, 8, ["modelValue", "length"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})